export default class EmailService {
  constructor($http) {
    this.$http = $http;
  }

  save_email_hostname(email_hostname) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_email_hostname',
      data: {email_hostname: email_hostname, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_recipient_modes() {
    return [
      {id: 0, title: 'to'},
      {id: 1, title: 'cc'}
    ];
  }

  get_sender_names_en() {
    return [
      'Petros Tsolpagas',
      'Andriana Faka'
    ];
  }

  get_sender_names_el() {
    return [
      'Πέτρος Τσολπάγκας',
      'Ανδριάνα Φάκα'
    ];
  }
}

EmailService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/email.service.js